import React, { PureComponent } from "react";
import {
    TreeList, mapTree, extendDataItem,
    TreeListSelectionCell, TreeListHeaderSelectionCell
} from '@progress/kendo-react-treelist';
import Images from "../../Assets/Images";
const subItemsField = "children";
const expandField = "expanded";
const selectField = "selected";

export default class OrganizationTreeList extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      expanded: [],
      selected: [],
      isLogged: true,
    };
  }

  componentDidUpdate() {
    if (this.props.orgUnitData && this.state.isLogged) {
      this.setState({
        ...this.state,
        data: this.props.orgUnitData,
        isLogged: false,
        selected: [],
      });

      if (this.props.selectedOrgUnit) {
        this.setState({
          ...this.state,
          data: this.props.orgUnitData,
          isLogged: false,
          selected: this.props.selectedOrgUnit,
        });
      }
    }
  }

  refreshData(data) {
    this.setState({
      ...this.state,
      selected: data,
    });
  }
  handleRowClick = (e) => {
    const selected = e.dataItem.selected
      ? this.state.selected.filter((x) => x !== e.dataItem.unitId)
      : [...this.state.selected, e.dataItem.unitId];
    this.setState({ selected });
  };

  onExpandChange = (e) => {
    var expanded = e.value
      ? this.state.expanded.filter((unitId) => unitId !== e.dataItem.unitId)
      : [...this.state.expanded, e.dataItem.unitId];

    this.setState({ ...this.state, expanded: expanded });
  };

  updateFields = (dataArr) => {
    const { expanded, selected } = this.state;
    return mapTree(dataArr, subItemsField, (item) =>
      extendDataItem(item, subItemsField, {
        expanded: expanded.includes(item.unitId),
        selected: selected.includes(item.unitId),
      })
    );
  };
  onSelectionChange = (event) => {
    this.changeSelection(event.dataItem);
  };

  childrenSelection = (childrenData) => {
    let childrenChecked = [];
    if (childrenData && childrenData.length > 0) {
      childrenData.forEach((element, index) => {
        childrenChecked.push(element.unitId);
        if (element.children) {
          let childList = this.childrenSelection(element.children);
          childrenChecked = [...childrenChecked, ...childList];
        }
      });
    }
    return childrenChecked;
  };

  changeSelection = (dataItem) => {
    let selected = [];
    if (dataItem.selected === false) {
      // if (dataItem.children) {
      //     selected = this.childrenSelection(dataItem.children);
      // }
      selected.push(dataItem.unitId);
      if (this.state.selected.length > 0) {
        this.state.selected.map((element) => {
          selected.push(element);
        });
      }
    } else if (dataItem.selected === true) {
      let unSelectedItem = [];
      // if (dataItem.children) {
      //     unSelectedItem = this.childrenSelection(dataItem.children);
      // }
      unSelectedItem.push(dataItem.unitId);
      selected = this.state.selected.filter(
        (val) => !unSelectedItem.includes(val)
      );
    }
    this.setState({ selected });
    if (selected.length == 0) {
      this.props.getEmptyRiskList(selected);
    } else {
      this.props.getRiskList(selected);
    }
  };
  onRowClick = (event) => {
    this.changeSelection(event.dataItem);
  };

  onHeaderSelectionChange = (event) => {
    const checked = event.syntheticEvent.target.checked;
    const selected = [];
    if (checked) {
      mapTree(this.state.data, subItemsField, (item) => {
        selected.push(item.unitId);
        return item;
      });
    }

    this.setState({ selected });

    if (selected.length == 0) {
      this.props.getEmptyRiskList(selected);
    } else {
      this.props.getRiskList(selected);
    }
  };

  headerSelectionValue = () => {
    let allSelected = true;
    const selected = this.state.selected;
    mapTree(this.state.data, subItemsField, (item) => {
      allSelected = allSelected && selected.includes(item.unitId);
      return item;
    });

    return allSelected;
  };

  render() {
    return (
      <TreeList
        style={{ maxHeight: "510px", overflow: "auto" }}
        data={this.updateFields(this.state.data)}
        selectedField={selectField}
        onSelectionChange={this.onSelectionChange}
        onHeaderSelectionChange={this.onHeaderSelectionChange}
        // onRowClick={ this.onRowClick }
        expandField={expandField}
        subItemsField={subItemsField}
        onExpandChange={this.onExpandChange}
        columns={[
          {
            field: "selected",
            title: "Select",
            width: "8%",
            headerSelectionValue: this.headerSelectionValue(),
            cell: (props) =>
              props.dataItem.isVisible ? (
                <TreeListSelectionCell {...props} />
              ) : (
                <span className="noaccess">
                  <img title="No access" src={Images.NOTACCESS} width="12" />
                </span>
              ),
            // cell: TreeListSelectionCell,
            headerCell: TreeListHeaderSelectionCell
          },
          {
            field: "name",
            title: "Workstream",
            expandable: true,
            width: "31%",
          },
        ]}
      />
    );
  }
}





